import React from 'react';
import {Typography} from "@deere/fuel-react";

export const ListItemSecondary = ({content}) => {
    return (
        <React.Fragment>
            <Typography color="tertiary" size="md" component="p"
                        gutterBottom>
                {content}
            </Typography>
        </React.Fragment>
    );
};
